"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("@/app/shared/constants");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const inputtext_1 = require("primereact/inputtext");
const utils_1 = require("primereact/utils");
const react_1 = require("react");
const InputText = ({ containerClassName, onDelayChange, ...props }) => {
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const [localValue, setLocalvalue] = (0, react_1.useState)(props.value);
    (0, react_1.useEffect)(() => {
        const handler = setTimeout(() => onDelayChange?.(localValue || ''), constants_1.DELAY_INPUT_UPDATE_MILLISECONDS);
        return () => clearTimeout(handler);
    }, [localValue]);
    (0, react_1.useEffect)(() => {
        setLocalvalue(props.value);
    }, [props.value]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: containerClassName ?? 'flex flex-column gap-10px', children: [(0, jsx_runtime_1.jsx)(inputtext_1.InputText, { ...props, className: (0, utils_1.classNames)('inputtext-sm', props.className), value: localValue, onChange: (e) => {
                    setLocalvalue(e.target.value);
                    props.onChange?.(e);
                }, onFocus: (e) => {
                    setIsFocused(true);
                    props.onFocus?.(e);
                }, onBlur: (e) => {
                    setIsFocused(false);
                    props.onBlur?.(e);
                } }), isFocused && props.maxLength && localValue?.length === props.maxLength && ((0, jsx_runtime_1.jsx)("div", { className: 'text-body-s-reg text-red-100', children: `${labels_1.default.CHARACTER_LIMIT_REACHED} (${props.maxLength})` }))] }));
};
exports.InputText = InputText;
